import { render, staticRenderFns } from "./InfoTextCard.vue?vue&type=template&id=0a4cc6cf&scoped=true&"
import script from "./InfoTextCard.vue?vue&type=script&lang=js&"
export * from "./InfoTextCard.vue?vue&type=script&lang=js&"
import style0 from "./InfoTextCard.vue?vue&type=style&index=0&id=0a4cc6cf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4cc6cf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VCardText,VCol,VIcon})
